/* eslint-disable @typescript-eslint/no-explicit-any */
export function debounce<T extends (...args: any[]) => Promise<void>>(callback: T, wait: number = 300, immediate = false) {
  let timeout: ReturnType<typeof setTimeout> | undefined

  return function(...args: any[]) {
    if(timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => {
      callback(...args)
    },
    wait)
  }
}